/**
 * @module builder
 */

import type { Product } from '../../../options'
import type { LineItemOperation } from '..'
import type { UpdateableLineItem } from '../../line-items'
import { updateLineItemProduct } from '../update-line-item-product/update-line-item-product'

export function bulkOperateLineItem(operation: LineItemOperation): UpdateableLineItem {
  let newLineItem = {
    ...operation.lineItem
  }
  // Complete each action on this lineItemOperation
  operation.actions.forEach((action: { oldProduct: string; newProduct: Product }) => {
    const updatedLineItem = updateLineItemProduct(action, newLineItem)
    newLineItem = updatedLineItem
  })

  return newLineItem
}
